import { useCallback, useMemo } from 'react';

import { MarginHistoricOrder, MarginOrdersQuery } from '@swyftx/margin/build/types';

import { useFetchMarginOrders } from './useFetchMarginOrders';
import { MarginHistoryDirection } from '../../types';

type Props = {
  pageSize?: number;
  side?: MarginHistoryDirection[];
  status?: string[];
  marketUuid?: string;
  sortBy?: MarginOrdersQuery['sortBy'];
  sortDir?: MarginOrdersQuery['sortDir'];
};

const useMarginOrders = ({ pageSize = 25, side, status, marketUuid, sortBy, sortDir }: Props = { pageSize: 25 }) => {
  const { data, fetchNextPage, fetchPreviousPage, isFetchingNextPage, hasNextPage, isFetching, isLoading, isError } =
    useFetchMarginOrders({
      pageSize,
      side: side?.join(','),
      status,
      marketUuid,
      sortBy,
      sortDir,
    });

  const orders = useMemo((): MarginHistoricOrder[] | undefined => data?.pages?.flatMap((p) => p.orders), [data?.pages]);

  const getOrderById = useCallback(
    (id?: number) => {
      if (!orders || !id) return undefined;
      return orders.find((d) => d.orderId === id);
    },
    [orders],
  );

  return {
    orders,
    isLoading,
    getOrderById,
    fetchNextPage,
    fetchPreviousPage,
    isFetchingNextPage,
    hasNextPage,
    isFetching,
    isError,
  };
};

export { useMarginOrders };
